<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="GeneralSettings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="h-100 overflow-auto px-3"
    v-if="loaded"
  >
    <DIV
      class="card my-3"
    >
      <DIV
        class="card-body"
      >
        <H5>
          {{ 'Email settings'|pgettext('Settings') }}
        </H5>
        <P
          class="card-text"
        >
          {{ 'Send a test email to the current user\'s email address.'|gettext }}
        </P>
        <ItpBox
          direction="column"
          alignItems="start"
        >
          <ItpButton
            :text="'Send test email'|pgettext('Tasks|Command')"
            icon="mdi:cog"
            :spinning="actions.sendmail.isRunning"
            @click.prevent.stop="evh_1269646916756998_clickPreventStop($event, {})"
          >
          </ItpButton>
          <ItpAlert
            type="success"
            :show="sendmailResult === true"
            dismissible
            class="mt-3"
          >
            <span>
              {{ 'Email has been successfully sent.'|pgettext('Settings') }}
            </span>
          </ItpAlert>
        </ItpBox>
      </DIV>
    </DIV>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.general",
    path: "general",
    component: "GeneralSettings"
  }
)

@Component()
export default class GeneralSettings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  sendmailResult!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['sendmailResult', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        sendmailResult: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_4932_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4932, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_1269646916756998_setData_4934_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1269646916756998_setData_4934, alias=undefined
    return {
      path: "sendmailResult",
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1269646916756998_setData_4938_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1269646916756998_setData_4938, alias=undefined
    return {
      path: "sendmailResult",
      value: true,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1269646916756998_request_4936_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1269646916756998_request_4936, alias=sendmail
    return {
      operation: "post_sendmail_test",
      data: {
      }
      ,
    }
  }

  async evh_1269646916756998_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1269646916756998_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4932: actions.CloseModalAction;
    evh_7315092382398562_close_4931: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_1269646916756998_setData_4934: actions.SetDataAction;
    evh_1269646916756998_clickPreventStop_4933: actions.EventHandlerImpl;
    act_1269646916756998_setData_4938: actions.SetDataAction;
    evh_1269646916756998_success_4937: actions.EventHandlerImpl;
    act_1269646916756998_request_4936: actions.RequestAction;
    evh_1269646916756998_clickPreventStop_4935: actions.EventHandlerImpl;
    evh_1269646916756998_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4932 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4932_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4931 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4932,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4931],
      }
    );
    const act_1269646916756998_setData_4934 = new actions.SetDataAction(
      {
        actionArgs: this.act_1269646916756998_setData_4934_getActionArgs,
        events: [],
      }
    );
    const evh_1269646916756998_clickPreventStop_4933 = new actions.EventHandlerImpl(
      {
        action: act_1269646916756998_setData_4934,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const act_1269646916756998_setData_4938 = new actions.SetDataAction(
      {
        actionArgs: this.act_1269646916756998_setData_4938_getActionArgs,
        events: [],
      }
    );
    const evh_1269646916756998_success_4937 = new actions.EventHandlerImpl(
      {
        action: act_1269646916756998_setData_4938,
        event: "success",
        displayName: "setData",
      }
    );
    const act_1269646916756998_request_4936 = new actions.RequestAction(
      {
        actionArgs: this.act_1269646916756998_request_4936_getActionArgs,
        displayName: "sendmail",
        events: [evh_1269646916756998_success_4937],
      }
    );
    const evh_1269646916756998_clickPreventStop_4935 = new actions.EventHandlerImpl(
      {
        action: act_1269646916756998_request_4936,
        event: "click.prevent.stop",
        displayName: "sendmail",
      }
    );
    const evh_1269646916756998_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1269646916756998_clickPreventStop_4933, evh_1269646916756998_clickPreventStop_4935],
      }
    );
    return {
      act_7315092382398562_closeModal_4932,
      evh_7315092382398562_close_4931,
      evh_7315092382398562_close,
      act_1269646916756998_setData_4934,
      evh_1269646916756998_clickPreventStop_4933,
      act_1269646916756998_setData_4938,
      evh_1269646916756998_success_4937,
      act_1269646916756998_request_4936,
      evh_1269646916756998_clickPreventStop_4935,
      evh_1269646916756998_clickPreventStop,
      sendmail: act_1269646916756998_request_4936,
    }
  }
}

Vue.component("GeneralSettings", GeneralSettings);

</script>